import { StyleSheet } from 'react-native';

export const friendStatsLoadingSkeletonStyles = StyleSheet.create({
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  nameSpacer: {
    marginTop: 8,
  },
  vsCenter: {
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 48,
  },
  cardList: {
    paddingHorizontal: 16,
    paddingTop: 16,
  },
  sectionHeader: {
    marginBottom: 12,
    marginTop: 8,
  },
  card: {
    marginBottom: 16,
  },
  cardBlock: {
    marginTop: 8,
  },
});
